import React from 'react'
import PropTypes from 'prop-types'

import Menu from './../block/Menu'
import Footer from './../block/Footer'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {
      data,
      user,
      restaurant,
      menu,
      showLocation,
      changeDeliveryType,
      favorite,
      changeFavorite,
      openProductWin,
      showFeedbackForm,
      showUsloviyaWin,
      lastOrder,
      assets_path,
      cart,
      leftMenu
    } = this.props

    return (
      <div className='font-manrope tracking-tight'>
        <Menu
          data={data}
          user={user}
          restaurant={restaurant}
          menu={menu}
          favorite={favorite}
          changeFavorite={changeFavorite}
          openProductWin={openProductWin}
          showLocation={showLocation}
          assets_path={assets_path}
          lastOrder={lastOrder}
          leftMenu={leftMenu}
        />
        <div className='container'>
          <Footer
            showFeedbackForm={showFeedbackForm}
            data={data}
            cart={cart}
            leftMenu={leftMenu}
          />
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  assets_path: PropTypes.string,
  data: PropTypes.object,
  protocol: PropTypes.string,
  user: PropTypes.object,
  restaurant: PropTypes.object,
  menu: PropTypes.array,
  showLocation: PropTypes.func,
  favorite: PropTypes.array,
  changeFavorite: PropTypes.func,
  openProductWin: PropTypes.func,
  showFeedbackForm: PropTypes.func,
  changeDeliveryType: PropTypes.func,
  showUsloviyaWin: PropTypes.func,
  lastOrder: PropTypes.object,
  cart: PropTypes.object,
  leftMenu: PropTypes.func
}

export default Main